import { c as _c } from "react/compiler-runtime";
// The plain TextField rather than FaroTextField: this one only displays a URL, so the save and
// clear buttons and the inline-edit styling of that component are not wanted here.
import { SphereLabel } from "@components/common/sphere-label";
import { useToast, TextField, Button } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { copyToClipboard } from "@utils/ui-utils";
/**
 * Renders a dialog to share a URL.
 * It has a text field that shows the URL and a button to copy it to the clipboard.
 */
export function SphereShareLink(t0) {
  const $ = _c(21);
  const {
    title,
    url,
    copyLogEventParams
  } = t0;
  const {
    openToast
  } = useToast();
  const {
    trackEvent
  } = useTrackEvent();
  let t1;
  if ($[0] !== copyLogEventParams || $[1] !== openToast || $[2] !== trackEvent || $[3] !== url) {
    t1 = function copyUrl() {
      copyToClipboard(url);
      trackEvent(copyLogEventParams);
      openToast({
        title: "Link copied"
      });
    };
    $[0] = copyLogEventParams;
    $[1] = openToast;
    $[2] = trackEvent;
    $[3] = url;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const copyUrl = t1;
  let t2;
  if ($[5] !== title) {
    t2 = <SphereLabel title={title} />;
    $[5] = title;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      alignItems: "stretch"
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      marginRight: "10px",
      gap: 0
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      borderTopRightRadius: "0",
      borderBottomRightRadius: "0",
      "&:focus-visible": {
        outline: "none"
      },
      "& .MuiInputBase-input": {
        textOverflow: "ellipsis"
      }
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== url) {
    t6 = <TextField fullWidth={true} text={url} controlStyle={t4} sx={t5} />;
    $[10] = url;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      marginLeft: "-10px",
      borderTopLeftRadius: "0px",
      borderBottomLeftRadius: "0px",
      minWidth: "80px"
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== copyUrl) {
    t8 = <Button sx={t7} onClick={copyUrl}>Copy</Button>;
    $[13] = copyUrl;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t8) {
    t9 = <Box component="div" sx={t3}>{t6}{t8}</Box>;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t2 || $[19] !== t9) {
    t10 = <Box component="div">{t2}{t9}</Box>;
    $[18] = t2;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}